import { Component, createRef } from "react";
import '../styles/style.css';
import { dbAdmin, user, isLoggedIn } from '../../App'
import { getFirestore, collection, getDocs, CollectionReference, DocumentData, query, orderBy, QueryDocumentSnapshot, Timestamp, where } from 'firebase/firestore/lite';
import { FaUnlock } from "react-icons/fa";

const loginReset = 1000 * 60 * 60 * 24; //24 Hours

class Login extends Component<any,any> {



    constructor(props: any) {
        super(props);
        
        this.state = {
            isLoggingIn: false,
        }
        
    }

    componentDidMount(): void {
        var loggedIn = localStorage.getItem('loggedIn');
        if (loggedIn != null) {
            var lastlogin = parseInt(loggedIn);
            var now = new Date().getTime();
            if (now - lastlogin < loginReset) {
                window.location.href = '/home';
            } else {
                localStorage.removeItem('loggedIn');
            }
        }
    }

    async login(f:any) {
        this.setState({isLoggingIn: true});
        var username = (document.getElementsByName('username')[0] as HTMLInputElement).value;
        var password = (document.getElementsByName('password')[0] as HTMLInputElement).value;

        var userCol = collection(dbAdmin, 'users');
        var q = query(userCol, where('username', '==', username), where('password', '==', password), where('active','==',true));
        var userSnapshot = await getDocs(q);
        
        if (userSnapshot.docs.length > 0) {
        
            var d = userSnapshot.docs[0].data();
            user.id = userSnapshot.docs[0].id;
            user.active = d.active;
            user.username = d.username;
            user.password = d.password;
            //globalThis.isLoggedIn = true;
            localStorage.setItem('loggedIn', new Date().getTime().toString());
            localStorage.setItem("user", JSON.stringify(d));
            window.location.href = '/home';
        }
        this.setState({isLoggingIn: false});
    }

    render() {
        
        return(<div className="overlay">
            
            <div style={{width: '80%', height: '300px', maxWidth: '400px', backgroundColor: 'white'}}>
                
                <div style={{height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <div style={{flex: .5, height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <img src='/logo192.png' style={{width: '75px', height: '75px'}}/>                    
                </div>
                <div style={{flex: 1.5, height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                        <span style={{fontSize: '20pt', fontFamily: 'avenirb', color: '#353535'}}>Starlight Bulldogs Login</span>
                    </div>
                </div>
                </div>
                <div style={{height: '200px', width: '100%', backgroundColor: 'rgba(166,0,0,.9)',display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                    <div style={{width: '80%',color: '#fff', fontSize: '9pt'}}>
                        USERNAME
                    </div>
                    <div style={{marginBottom: '20px', width: '80%',color: '#fff', fontSize: '9pt'}}>
                        <input type="text" name="username" style={{width: '100%', height: '20px', backgroundColor: '#fff', color: '#333', borderRadius: '10px', padding: '5px', border: '1px solid #fff'}}/>
                    </div>
                    
                    <div style={{width: '80%',color: '#fff', fontSize: '9pt'}}>
                        PASSWORD
                    </div>
                    <div style={{marginBottom: '10px', width: '80%',color: '#fff', fontSize: '9pt'}}>
                        <input type="password" name="password" style={{width: '100%', height: '20px', backgroundColor: '#fff', color: '#333', borderRadius: '10px', padding: '5px', border: '1px solid #fff'}}/>
                    </div>
                    <div style={{ width: '80%',color: '#fff', fontSize: '9pt', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                        
                        <button onClick={this.login.bind(this)} name="loginBtn" style={{width: '50%', backgroundColor: 'rgba(0,0,0,.8)', color: '#fff', border: 'none', borderRadius: '10px', padding: '15px'}}><FaUnlock style={{marginRight: '10px'}}/>Login</button>
                    </div>
                </div>
                
            </div>
            {this.state.isLoggingIn ?
            <div style={{position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.8)', justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                <div style={{width: '80%', textAlign: 'center', color: '#fff'}}>
                    LOGGING IN...
                    <progress style={{width: '100%', height: '10px'}}></progress>
                </div>
            </div> : null}
        </div>)
    }
}

export default Login;